import router from "@/config/router";
import i18n from "@/config/i18n";
import store from "@/config/store"

export interface HeadMetadata {
    title: string
    description: string
    properties?: {name: string, content: string}[]
}

export function updateHeadMetadata(metadata?: HeadMetadata) {
    const i18nPageKey = 'seo.' + pascalToKebabCase(router.currentRoute.matched.map(route => route.name).filter(name => !!name).join('.'))
    const routeTitle = getI18nOrNull(i18nPageKey + '.title')
    const routeDescription = getI18nOrNull(i18nPageKey + '.description')
    const prefix = getI18nOrNull('seo.titlePrefix', {rootCategoryLabel: store.state.category.rootCategory?.label})
    const suffix = getI18nOrNull('seo.titleSuffix', {rootCategoryLabel: store.state.category.rootCategory?.label})

    // const reversedMatchedcRoutes = router.currentRoute.matched.slice().reverse()
    // console.debug("reversedMatchedcRoutes", reversedMatchedcRoutes)
    // const nearestTitle = reversedMatchedcRoutes.find(r => r.meta?.title)?.meta.title || '';
    // const nearestTitlePrefix = reversedMatchedcRoutes.find(r => r.meta?.titlePrefix)?.meta.titlePrefix || '';
    // const nearestTitleSuffix = reversedMatchedcRoutes.find(r => r.meta?.titleSuffix)?.meta.titleSuffix || '';
    // const nearestDescription = reversedMatchedcRoutes.find(r => r.meta?.description)?.meta.description || '';

    // Remove any stale meta tags from the document using the key attribute we set below.
    Array.from(document.querySelectorAll('head meta[data-ork-dynamic-meta]')).map(el => document.head.removeChild(el))

    const title = [prefix, metadata?.title || routeTitle || getI18nOrNull('seo.defaultTitle'), suffix].join('')
    const description = metadata?.description || routeDescription || getI18nOrNull('seo.defaultDescription') || ''

    // Set url
    document.querySelector('head meta[property="og:url"]')?.setAttribute('content', window.location.origin + router.currentRoute.fullPath)

    // Set title and description
    document.title = title;
    document.querySelector('head meta[property="og:title"]')?.setAttribute('content', title);
    document.querySelector('head meta[name="description"]')?.setAttribute('content', description);
    document.querySelector('head meta[property="og:description"]')?.setAttribute('content', description);

    // Set additional properties
    metadata?.properties?.map(property => {
        const tag = document.createElement('meta');
    
        tag.setAttribute("property", property.name);
        tag.setAttribute("content", property.content);
    
        // We use this to track which meta tags we create so we don't interfere with other ones.
        tag.setAttribute('data-ork-dynamic-meta', '');
    
        return tag;
      })
      // Add the meta tags to the document head.
      .forEach(tag => document.head.appendChild(tag));
}

const getI18nOrNull = (key, params?) => {
    const i18nValue = i18n.t(key, params || {}).toString()
    return i18nValue === key ? null : i18nValue
}

export const camelToSnakeCase = str => str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
export const pascalToSnakeCase = (str: string) => str.substring(0,1).toLowerCase() + str.substring(1).replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
export const camelToKebabCase = str => str.replace(/[A-Z]/g, letter => `-${letter.toLowerCase()}`);
export const pascalToKebabCase = (str: string) => str.substring(0,1).toLowerCase() + str.substring(1).replace(/[A-Z]/g, letter => `-${letter.toLowerCase()}`);